import { render } from "./App.vue?vue&type=template&id=619fdb7e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=619fdb7e&lang=scss"

import exportComponent from "/Users/silvan.muehlemann/PycharmProjects/poster-markus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__